import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { TouchableOpacity, TWCText } from '@components';
import { useRecoilState } from 'recoil';

import { settingsMenuTestIDs, settingsPageTestIDs, Theme } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';
import { userSettingsState } from '@store';

import { styles } from './styles';

import ToggleOnIcon from '../../../assets/icons/editIcons/toggle-on.png';
import { FocusableSwitch } from '../../focusable/FocusableSwitch/FocusableSwitch';

export const SettingsAlerts: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'settingsPage.alerts',
  });
  const [userSettings, setUserSettings] = useRecoilState(userSettingsState);
  const [alertsEnabled, setAlertsEnabled] = useState(userSettings.alertsEnabled);
  const alertsMenuHandle = useContextNodeHandle(settingsMenuTestIDs.alerts);
  const settingsAlertSwitchReference = useContextReference<TouchableOpacity>(
    settingsPageTestIDs.alerts.settingsAlertsSwitch,
  );

  useEffect(() => {
    const newSettings = { ...userSettings };

    newSettings.alertsEnabled = alertsEnabled;
    setUserSettings(newSettings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertsEnabled]);

  return (
    <View style={styles.settingsAlertsWrapper}>
      <TWCText
        style={styles.settingsAlertsTopContent}
        testID={settingsPageTestIDs.alerts.settingsAlertsText}
        variant={'regularText36'}
      >
        {alertsEnabled ? t('severeAlertsTextOn') : t('severeAlertsTextOff')}
      </TWCText>
      <FocusableSwitch
        accessibilityHint={t('switchAccessibilityHint')}
        accessibilityLabel={
          alertsEnabled ? t('switchAccessibilityLabelEnabled') : t('switchAccessibilityLabelDisabled')
        }
        activeText={t('switchActiveText')}
        backgroundActive={Theme.switch.activeColor}
        backgroundInactive={Theme.switch.inactiveColor}
        barHeight={Theme.px(80)}
        changeValueImmediately
        circleBorderWidth={0}
        circleSize={Theme.px(54)}
        colorFocused={Theme.switch.focusColor}
        inActiveText={t('switchInactiveText')}
        nativeID={settingsPageTestIDs.alerts.settingsAlertsSwitch}
        nextFocusDown={undefined}
        nextFocusLeft={alertsMenuHandle}
        nextFocusRight={undefined}
        nextFocusUp={undefined}
        ref={settingsAlertSwitchReference}
        renderInsideCircle={() => (alertsEnabled ? <Image source={ToggleOnIcon} style={styles.checkIcon} /> : <></>)}
        switchLeftPx={2}
        switchRightPx={2}
        switchWidthMultiplier={3.15}
        testID={settingsPageTestIDs.alerts.settingsAlertsSwitch}
        value={alertsEnabled}
        onValueChange={() => setAlertsEnabled(!alertsEnabled)}
      />
    </View>
  );
};
